export default __webpack_public_path__ + "hero-tablet-2130316b9be2f8332c43fc72442889d3.digested.webp";